import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Homepage } from './pages/Homepage/Homepage';
import { UIKit } from './pages/UIKit/UIKit';
import './styles/reset.css';
import './styles/common.css';
import './styles/main.scss';
import Products from './pages/Products';
import Resources from './pages/Resources';
import MainLayout from './Layout/main';
import AboutProducts from 'pages/AboutProduct';
import RelatedProduct from 'pages/RelatedProduct';

const router = createBrowserRouter([
    {
        path: '/',
        element: (
            <MainLayout>
                <Homepage />
            </MainLayout>
        ),
    },
    {
        path: '/ui-kit',
        element: <UIKit />,
    },
    {
        path: 'products',
        element: (
            <MainLayout>
                <Products />
            </MainLayout>
        ),
    },
    {
        path: 'about-product',
        element: (
            <MainLayout>
                <AboutProducts />
            </MainLayout>
        ),
    },
    {
        path: 'related-product',
        element: (
            <MainLayout>
                <RelatedProduct />
            </MainLayout>
        ),
    },
    {
        path: 'resources',
        element: (
            <MainLayout>
                <Resources />
            </MainLayout>
        ),
    },
]);

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>,
);
